import React from "react";
import { ScrollView, StyleSheet } from "react-native";

import { EventSummary } from "./Components/EventSummary";

import { useEvents } from "@/screens/Content/Feed/EventsTab/Hooks/useEvents";
import { ContentTabs, Screen } from "@/schemas/screen/tabs";
import { type ContentScreenState } from "@/schemas/screen/configs";
import { eventFilterOptions } from "@/schemas/events/filter/eventFiltersOptions";

export function EventCountPanel(): React.JSX.Element {
  const initialScreen: ContentScreenState = {
    screenId: Screen.CONTENT,
    activeTabId: ContentTabs.EVENTS,
    filters: null,
  };

  const { events } = useEvents(initialScreen);

  const styles = StyleSheet.create({
    scrollView: {
      maxWidth: "20%",
    },
  });

  return (
    <ScrollView style={styles.scrollView}>
      {/* <JoinNowCard /> */}
      {eventFilterOptions
        .sort((a, b) => a.rank - b.rank)
        .map((section) => (
          <EventSummary key={section.label} section={section} events={events} />
        ))}
    </ScrollView>
  );
}
